// @ts-strict-ignore
import {
  AfterViewInit,
  Component, Input, OnInit, ViewChild
} from '@angular/core';
import { LMRouteComponentService } from '@services/lm-route-component.service';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  LMContextService, LMErrorUtilService,
  LMFormatUtilService,
  LMLoggerService, LMUrlUtilService, NameValueMap,
  URLOptions
} from '@app/services';
import { LMGenAIPanel, LMGenAISummaryParams } from '@modal/lm-genai-summarize-dialog';
import { LMModel } from '@form/model';
import { AppConstants } from '@app/utils';
import {
  SohoBusyIndicatorDirective,
  SohoButtonComponent, SohoEditorComponent, SohoTextAreaComponent,
} from 'ids-enterprise-ng';
import { catchError } from 'rxjs/operators';
import {LMFormRequestService, LMListGridPagingService} from '@app/components';

import {
  LMGenAIModel,
  LMGenAIModelResponse,
  LMGenAIModelStateValue, LMGenAIModelVersion
} from '@modal/lm-genai-prompt-dialog';
import { ListResource } from '@app/resources';

@Component({
  selector: 'lm-genai-summarize',
  standalone: false,
  templateUrl:  'lm-genai-summarize-dialog.component.html',
  styleUrls:    [ 'lm-genai-summarize-dialog.component.scss' ],
  providers: [ LMRouteComponentService ]
  })
export class LMGenAISummarizeDialogComponent implements OnInit {
  constructor(private http: HttpClient,
    private lmContextService: LMContextService,
    private lmLoggerService: LMLoggerService,
    private lmFormatUtilService: LMFormatUtilService,
    private lmUrlUtilService: LMUrlUtilService,
    private lmFormRequestService: LMFormRequestService,
    private lmErrorUtilService: LMErrorUtilService,
    private lmListGridPagingService: LMListGridPagingService,
  ) {}

  @Input() generatedText: string;
  @Input() fieldId: string;
  @Input() dataView: LMDataView;
  @Input() formSpec: LMBusFormSpec;
  @Input() panelSpecs: Array<LMCompositePanelSpec> = [];
  @Input() resource: Resource;
  @Input() selectedTabIndex: number;
  @Input() model: LMModel;

  @Input() fromResource: Resource;
  @Input() fromList: Resource;
  @Input() actionReference: LMBusActionReference;
  @Input() name: string;
  @Input() chartName: string;
  @Input() dataViewSet: LMDataViewSet;
  @Input() cubeOverrides: LMCubeOverrides;
  @Input() cubeOptions: LMCubeOptions;
  @Input() userFolder: string;
  @Input() selectedRows: number[];
  @Input() filterFields: LMFilterFieldCriteria[];
  @Input() selectRequestData: SelectRequestData;
  @Input() pdfType: string;
  @Input() includeSearchForm: boolean;
  //@ViewChild(SohoEditorComponent) editor: SohoEditorComponent;
  @ViewChild(SohoButtonComponent) generateButton: SohoButtonComponent;
  @ViewChild(SohoTextAreaComponent) editor: SohoTextAreaComponent;
  @ViewChild(SohoBusyIndicatorDirective) _busyIndicator: SohoBusyIndicatorDirective;

  public valid = true;
  public summarize = false;
  public panels: Array<LMGenAIPanel> = [];
  private selectedTabIndexes: Array<number> = [];
  public printOptions: LMPrintOption[];
  public printOption: LMPrintOption = { 'label': 'PDF_CURRENT_LIST', value: AppConstants.PDF_ACTION };
  public defaultPrompt: string;
  public llmModels: LMGenAIModelStateValue[] = [];
  public llmModel: LMGenAIModelStateValue;
  public developerMode = this.lmContextService.isDeveloper();
  private loadingWrapper: HTMLElement = null;
  private isLoading = false;
  public loadingId = 'lm-genai-loading-wrapper';

  public getDataView() {
    return this.dataView;
  }

  public summaryField = {
    value: ''
  };

  public genAIPrompt = {
    value: ''
  };

  public defaultGenAIPrompt = {
    value: ''
  };

  get _resource(): Resource {
    // Switch Resource to selected record when printing
    // with 'Selected Record With Details' option is chosen
    const printOption = Number(this.printOption.value);
    if (printOption === AppConstants.PDF_SELECTED_WITH_DETAILS_ACTION
      && this.dataViewSet.data.length
      && this.selectedRows.length) {
      const listResource = <ListResource>this.resource;
      return new ListResource({
        resourceId: this.dataViewSet.data[this.selectedRows[0]].resourceId,
        listName: listResource.listName
      });
    }

    return this.resource;
  }

  protected set busyIndicator(value: boolean) {
    if (this._busyIndicator) {
      this._busyIndicator.activated = value;
    }
  }

  ngOnInit() {
    this.printOptions = this.getPrintOptions();
    this.printOption = this.printOptions ? this.printOptions[0] : null;

    this.defaultPrompt = this.lmContextService.getGenAISummarizePrompt();
    this.defaultGenAIPrompt.value = this.defaultPrompt;

    if (this.developerMode) {
      this.loadingId += '-dev';
      this.populateLlmModels();
    }
  }

  ngAfterViewInit() {
    if(!this.developerMode) {
      setTimeout(() => {
        this.generate();
      }, 300);
    }
  }

  trackByValue(index: number, state: LMStateValue) {
    return state.value;
  }

  generate(event?: Event) {
    this.summaryField.value = '';
    this.processSummarize();
  }

  onPrintOptionChanged(value) {
    const optionValue: number = parseInt(value);
    this.printOption = this.printOptions.filter(option =>  option.value ===  optionValue)[0];
  }

  populateLlmModels() {
    this.busyIndicator = true;
    this.prepareGenAILLMModels()
      .subscribe((result: LMGenAIModelResponse) => {
          if (result.models) {
            this.handleGenAILLMModelResponse(result);
          }
          setTimeout(() => {
            this.busyIndicator = false;
          }, 1);
        });
  }

  prepareGenAILLMModels(): Observable<LMGenAIModelResponse> {
    const params: LMGenAISummaryParams = { output : 'genai' };
    const url = this.buildUrl(params);
    return this.lmFormRequestService.getGenAILLMModels(url);
  }

  handleGenAILLMModelResponse(result: LMGenAIModelResponse): Array<LMGenAIModelStateValue> {
    this.modelStatesToOptionsArray(result);

    return this.llmModels;
  }

  modelStatesToOptionsArray(result: LMGenAIModelResponse) {
    this.llmModels = [];

    for (let i = 0, len = result.models.length; i < len; i++) {
      const model: LMGenAIModel = result.models[ i ];
      for (let j = 0, len = model.versions.length; j < len; j++) {
        const version: LMGenAIModelVersion = model.versions[ j ];

        this.llmModels.push({'name': model.name, 'label': version.id, 'value': version.id, 'tooltip': version.description });
      }
    }
  }

  toggleLoadingIndicator() {
    if (!this.loadingWrapper) {
      this.loadingWrapper = document.getElementById(this.loadingId);
    }
    if (!this.isLoading) {
      this.isLoading = true;
      const loadingIndicator = $('<div id="ai-loading-indicator" class="ai-loading-indicator"><div class="bar"></div><div class="bar"></div><div class="bar"></div></div>');
      loadingIndicator.appendTo(this.loadingWrapper);
    } else {
      this.isLoading = false;
      this.loadingWrapper?.querySelector('.ai-loading-indicator')?.remove();
    }
  }

  processSummarize() {
    this.runSummarize().subscribe(
      (data: Blob) => {
        (this.generateButton as any)?.button.stopAnimation();
        const blob = new Blob([ data ], { type: 'application/json' });

        //TODO: check the configuration parameter, if return.input is true, no parsing is needed, as the return value is already in JSON format
        (new Blob([ data ]).text().then(value => {
          if (this.lmContextService.genAISummarizeBase64()) {
            this.summaryField.value = value;
          } else {
            const jsonValue = JSON.parse(value);
            let content = '';
            if (jsonValue.content) {
              content = jsonValue.content.trim();
            } else if (jsonValue.message) { //message contains error
              const message = jsonValue.message.trim();
              const title = Soho.Locale.translate('Error');
              this.lmErrorUtilService.handleViewException({ message, title });
            } else {
              content = value;
            }
            this.summaryField.value = content;
          }
          this.toggleLoadingIndicator();
        }));
      }
    );
  }

  public runSummarize(): Observable<Blob> {
    this.toggleLoadingIndicator();

    const formRequest = {
      requestType: 'genAISummarize',
      // selectedTabIndexes: this.selectedTabIndexes,
      selectedTabIndex: this.selectedTabIndex,
      dataView: this.dataView,
      pdfOption: this.printOption ? this.printOption.value : AppConstants.PDF_ACTION,
      prompt: this.defaultGenAIPrompt.value + ' ' + this.genAIPrompt.value,
      llmModel: '',
      llmVersion: '',
    };
    if (this.llmModel) { // This will only be true if the user is in developer mode and has selected an LLM model
      const llm = this.llmModels.filter(option =>  option.value ===  this.llmModel)[0];
      formRequest.llmModel = llm.name;
      formRequest.llmVersion = llm.value;
    }
    const pageSize = (this.dataViewSet) ? this.dataViewSet.pagingInfo.pageSize : 0;

    let url = this.lmListGridPagingService.buildReloadUrl(this.dataViewSet, pageSize, this.cubeOptions, null, null, null);
    url = this.lmUrlUtilService.updateUrlParams(url, this.getSummarizeRequestParams() as LMUrlParams);
    const headers = new HttpHeaders({ 'Content-Type': 'application/json;charset=utf-8' });

    return <Observable<Blob>>this.http.post(url, JSON.stringify(formRequest), { headers, responseType: 'blob' }).pipe(
      catchError(error => {
        this.toggleLoadingIndicator();
        this.lmLoggerService.error(error);
        (this.generateButton as any)?.button.stopAnimation();
        return throwError(error || 'Server error');
    }));

  }

  private buildUrl(commonParams?: LMGenAISummaryParams): string {
    const urlOptions = {
      resource: this.printOption ? this._resource : this.resource,
      params: commonParams,
    } as URLOptions;
    return this.lmUrlUtilService.buildUrl(urlOptions);
  }

  private getSummarizeRequestParams(): LMGenAISummaryParams {
    let params: LMGenAISummaryParams = { output : 'genai' };

    if (this.cubeOverrides) {
      params.cubeOverrides = this.cubeOverrides;
    } else if (this.cubeOptions) {
      // Cube options contain array of objects for each dimension type such as context, filter and current cube
      // They are kept separate in different collections and DataViewCubeInfo object is built before fetching data.
      params.cubeOptions = this.cubeOptions;
    }
    if (this.fromResource) {
      // url util service encodes parameters
      params[this.fromResource.resourceType] = this.fromResource.generateResourceId(false);
    }
    if (this.fromList) {
      // url util service encodes parameters
      params['fromlist'] = this.fromList.generateResourceId(false);
    }
    // as of now, there is no possible way to identify a Matrix Spreadsheet and a Matrix Compare
    // they both have the same LPL syntax construct and the same spec
    // the only way to differentiate the two is via url item params
    // when item is present in the url, the form is Matrix Compare (hence ITEM compare)
    // absence of item in the url params means it is a Matrix Spreadsheet.
    // this is both true with export to csv and pdf
    if (this?.dataView?.columnList && this.lmUrlUtilService.hasParam(window.location.href, 'item')) {
      const items: string[] = [];
      this.dataView.columnList.forEach((dataView: LMDataView) => {
        items.push(dataView.resourceId);
      });
      params['item'] = items;
    }
    // Append PagingInfo from DataViewSet
    const pagingInfo = (this.dataViewSet) ? this.dataViewSet.pagingInfo : {};
    if (pagingInfo.filter) {
      params.filter = pagingInfo.filter;
    }
    params.maxRows = pagingInfo.pageSize;

    // TODO: Refactor this with backend and use filters from LMPrintRequestData
    // instead of having two separate places to send filter criteria
    if (this.filterFields?.length) {
      const filterFields = this.lmUrlUtilService.filterFieldCriteriaToNameValueMap(this.filterFields, 'fc');
      filterFields.forEach((filter: NameValueMap) => {
        params = { ...params, ...filter };
      });
    }
    return params;
  }

  /**
   * Returns a set print options based on PDF type
   * @return Array of print options
   */
  getPrintOptions(): LMPrintOption[] {
    const options: { [index: string]: LMPrintOption[] } = {};
    const formatOption = (value, label) => ({ value, label: Soho.Locale.translate(label) });

    options[AppConstants.COMPOSITE_FORM_PDF] = [
      formatOption(AppConstants.PDF_ALL_TABS_ACTION, 'PDFAllTabs'),
      formatOption(AppConstants.PDF_SELECTED_TAB_ACTION, 'PDFSelectedTab'),
    ];
    options[AppConstants.LIST_WITH_DETAILS_PDF] = [
      formatOption(AppConstants.PDF_ACTION, 'PDFCurrentList'),
      formatOption(AppConstants.PDF_WITH_DETAILS_ACTION, 'PDFWithDetails'),
      formatOption(AppConstants.PDF_SELECTED_WITH_DETAILS_ACTION, 'PDFSelectedWithDetails'),
    ];
    options[AppConstants.TREE_LIST_PDF] = [
      formatOption(AppConstants.PDF_ACTION, 'PDFDefaultTree'),
      formatOption(AppConstants.PDF_EXPANDED_ACTION, 'PDFAllLevels'),
      formatOption(AppConstants.PDF_SPECIFIED_ACTION, 'PDFSpecifiedMaxLevels'),
    ];
    options[AppConstants.TREE_LIST_WITH_DETAILS_PDF] = [
      formatOption(AppConstants.PDF_ACTION, 'PDFDefaultTree'),
      formatOption(AppConstants.PDF_WITH_DETAILS_ACTION, 'PDFRootLevelsWithDetails'),
      formatOption(AppConstants.PDF_EXPANDED_ACTION, 'PDFAllLevels'),
      formatOption(AppConstants.PDF_EXPANDED_WITH_DETAILS_ACTION, 'PDFAllLevelWithDetails'),
      formatOption(AppConstants.PDF_SPECIFIED_ACTION, 'PDFSpecifiedMaxLevels'),
      formatOption(AppConstants.PDF_SPECIFIED_WITH_DETAILS_ACTION, 'PDFSpecifiedMaxLevelsWithDetails'),
      formatOption(AppConstants.PDF_SELECTED_WITH_DETAILS_ACTION, 'PDFSelectedWithDetails'),
    ];

    // Exclude PDF_SELECTED_WITH_DETAILS_ACTION when there is no selected row/s
    // if (!this.printInfo.selectedRows?.length) {
    //   options[this.pdfType] = options[this.pdfType].filter((option: LMPrintOption) => option.value !== AppConstants.PDF_SELECTED_WITH_DETAILS_ACTION);
    // }

    return options[this.pdfType];
  }
}
